const $ = jQuery.noConflict();

class Slider {
	constructor(selector, args = {}) {
		this.selector = selector;
		this.args = args;
	}

	getDefaultSlickSettings() {
		return {
			dots: false,
			arrows: true,
			infinite: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			pauseOnHover: false,
			useProgress: false,
			speed: 600,
		};
	}

	/**
	 * Override our default slick settings with args provided to the class.
	 */
	getSlickSettings() {
		return Object.assign({}, this.getDefaultSlickSettings(), this.args);
	}

	init() {
		const settings = this.getSlickSettings();
		const slider = $(this.selector);

		slider.slick(settings);

		if (settings.useProgress) {
			const progressbar = slider.next('.slick-progress');
			slider.on(
				'beforeChange',
				function (event, slick, currentSlide, nextSlide) {
					const calc = (nextSlide / (slick.slideCount - 1)) * 100;

					progressbar
						.css('background-size', calc + '% 100%')
						.attr('aria-valuenow', calc);
				}
			);
		}
	}
}

const SimpleSlider = new Slider('.gallery-slider__slider');
const TestimonialSlider = new Slider('.testimonial-slider');
const FluidSlider = new Slider('.gallery-slider__slider-fluid', {
	centerMode: true,
	variableWidth: true,
	responsive: [
		{
			breakpoint: 1290,
			settings: {
				centerMode: false,
				variableWidth: false,
			},
		},
	],
});
const TeamSlider = new Slider(`.block-team-slider__slider`, {
	dots: false,
	variableWidth: true,
	useProgress: true,
	infinite: false,
	responsive: [
		{
			breakpoint: 992,
			settings: {
				variableWidth: false,
				slidesToShow: 3,
				slidesToScroll: 3,
			},
		},
		{
			breakpoint: 768,
			settings: {
				variableWidth: false,
				slidesToShow: 2,
				slidesToScroll: 2,
			},
		},
	],
});
export { SimpleSlider, TestimonialSlider, FluidSlider, TeamSlider };
